!function(window) {
// babel-polyfills
// require("babel-polyfill");


/**
 * Cookie plugin
 *
 * Copyright (c) 2006 Klaus Hartl (stilbuero.de)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */
jQuery.cookie = function (name, value, options) {
	if (typeof value != "undefined") {
		options = options || {};
		if (value === null) {
			value = "";
			options.expires = -1
		}
		var expires = "";
		if (options.expires && (typeof options.expires == "number" || options.expires.toUTCString)) {
			var date;
			if (typeof options.expires == "number") {
				date = new Date();
				date.setTime(date.getTime() + (options.expires * 24 * 60 * 60 * 1000))
			} else {
				date = options.expires
			}
			expires = "; expires=" + date.toUTCString()
		}
		var path = options.path ? "; path=" + (options.path) : "";
		var domain = options.domain ? "; domain=" + (options.domain) : "";
		var secure = options.secure ? "; secure" : "";
		document.cookie = [name, "=", encodeURIComponent(value), expires, path, domain, secure].join("")
	} else {
		var cookieValue = null;
		if (document.cookie && document.cookie != "") {
			var cookies = document.cookie.split(";");
			for (var i = 0; i < cookies.length; i++) {
				var cookie = jQuery.trim(cookies[i]);
				if (cookie.substring(0, name.length + 1) == (name + "=")) {
					cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
					break
				}
			}
		}
		return cookieValue
	}
};

require("../jquery-extended-arctur")(jQuery);
require("../form.validators")(jQuery);

// URL plugin

jQuery.url = function () {
	var segments = {};
	var parsed = {};
	var options = {
		url: window.location,
		strictMode: false,
		key: ["source", "protocol", "authority", "userInfo", "user", "password", "host", "port", "relative", "path", "directory", "file", "query", "anchor"],
		q: {
			name: "queryKey",
			parser: /(?:^|&)([^&=]*)=?([^&]*)/g
		},
		parser: {
			strict: /^(?:([^:\/?#]+):)?(?:\/\/((?:(([^:@]*):?([^:@]*))?@)?([^:\/?#]*)(?::(\d*))?))?((((?:[^?#\/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/,
			loose: /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*):?([^:@]*))?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/
		}
	};
	var parseUri = function () {
		var str = decodeURI(options.url);
		var m = options.parser[options.strictMode ? "strict" : "loose"].exec(str);
		var uri = {};
		var i = 14;
		while (i--) {
			uri[options.key[i]] = m[i] || ""
		}
		uri[options.q.name] = {};
		uri[options.key[12]].replace(options.q.parser, function ($0, $1, $2) {
			if ($1) {
				uri[options.q.name][$1] = $2
			}
		});
		return uri
	};
	var key = function (key) {
		if (!parsed.length) {
			setUp()
		}
		if (key == "base") {
			if (parsed.port !== null && parsed.port !== "") {
				return parsed.protocol + "://" + parsed.host + ":" + parsed.port + "/"
			} else {
				return parsed.protocol + "://" + parsed.host + "/"
			}
		}
		return (parsed[key] === "") ? null : parsed[key]
	};
	var param = function (item) {
		if (!parsed.length) {
			setUp()
		}
		return (parsed.queryKey[item] === null) ? null : parsed.queryKey[item]
	};
	var setUp = function () {
		parsed = parseUri();
		getSegments()
	};
	var getSegments = function () {
		var p = parsed.path;
		segments = [];
		segments = parsed.path.length == 1 ? {} : (p.charAt(p.length - 1) == "/" ? p.substring(1, p.length - 1) : p.substring(1)).split("/")
	};
	return {
		setMode: function (mode) {
			strictMode = mode == "strict" ? true : false;
			return this
		},
		setUrl: function (newUri) {
			options.url = newUri === undefined ? window.location : newUri;
			setUp();
			return this
		},
		segment: function (pos) {
			if (!parsed.length) {
				setUp()
			}
			if (pos === undefined) {
				return segments.length
			}
			return (segments[pos] === "" || segments[pos] === undefined) ? null : segments[pos]
		},
		attr: key,
		param: param
	}
}();


// nastavi invisible recaptcho za vse forme in jo pokliče na submit forme

var captchaCallback = function(){
	var widgetAttr = 'data-widgetid';
	var recaptchaClass = '.g-recaptcha';
	var recaptchaRespons = '.g-recaptcha-response';
	$(recaptchaClass).each(function(index, el) {
		var form = $(el).closest("form");
		var widgetId = grecaptcha.render(el, {
			'sitekey' : jQuery(el).attr('data-sitekey'), 
			'callback' : token => {
				form.find(recaptchaRespons).val(token);
				//form.submit();
			}
		});
		$(el).attr(widgetAttr, widgetId);
	});

	$('.arctur-form [type=submit]').on('click', function(ev) {
		ev.preventDefault();
		var widgetId = $(this).closest('form').find(recaptchaClass).attr(widgetAttr);
		//grecaptcha.execute(widgetId);	
	});
}


//global variables for responsivness

var urlDirFull = jQuery.url.attr("directory");
var pageLng = null;


function initilizeLanguageSettings() {
	/* --- language settings --- */

	var htmlLang = $('html').attr('lang');
	if (htmlLang == 'sl') {
		pageLng = 'slo';
	} else if (htmlLang == 'it') {
		pageLng = 'ita';
	} else if (htmlLang == 'de') {
		pageLng = 'deu';
	} else if (htmlLang == 'hr') {
		pageLng = 'hrv';
	} else {
		pageLng = 'eng';
	}

	if (pageLng == 'slo' || pageLng == 'hrv') {
		Date.format = 'dd.mm.yyyy';
		Date.firstDayOfWeek = 1;
		Date.dayNames = ['Nedelja', 'Ponedeljek', 'Torek', 'Sreda', 'Četrtek', 'Petek', 'Sobota'];
		Date.abbrDayNames = ['Ned', 'Pon', 'Tor', 'Sre', 'Čet', 'Pet', 'Sob'];
		Date.monthNames = ['januar', 'februar', 'marec', 'april', 'maj', 'junij', 'julij', 'avgust', 'september', 'oktober', 'november', 'december'];
		Date.abbrMonthNames = ['jan', 'feb', 'mar', 'apr', 'maj', 'jun', 'jul', 'avg', 'sep', 'okt', 'nov', 'dec'];

		$.dpText = {
			TEXT_PREV_YEAR: 'Prejšnje leto',
			TEXT_PREV_MONTH: 'Prejšnji mesec',
			TEXT_NEXT_YEAR: 'Naslednje leto',
			TEXT_NEXT_MONTH: 'Naslednji mesec',
			TEXT_CLOSE: 'Zapri',
			TEXT_CHOOSE_DATE: 'Izberi datum'
		}
	} else {
		Date.format = 'dd.mm.yyyy';
		Date.firstDayOfWeek = 1;
		Date.dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
		Date.abbrDayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
		Date.monthNames = ['January', 'February', 'March', 'April', 'May', 'Jun', 'Julay', 'August', 'September', 'October', 'November', 'December'];
		Date.abbrMonthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

		$.dpText = {
			TEXT_PREV_YEAR: 'Previews year',
			TEXT_PREV_MONTH: 'Previews month',
			TEXT_NEXT_YEAR: 'Next year',
			TEXT_NEXT_MONTH: 'Next month',
			TEXT_CLOSE: 'Close',
			TEXT_CHOOSE_DATE: 'Select date'
		}
	}
}

//initialize autocomplete - needed for responsivness so its called again on window resize
function initializeAutoComplete() {
	$("#input-search-mini, #input-search-main").autocomplete("/util/string_search.php?lng=" + pageLng, {
		appendTo: '#search-mini-form',
		matchContains: true,
		//mustMatch: true,
		//minChars: 0,
		//multiple: true,
		//highlight: false,
		//multipleSeparator: ",",
		selectFirst: false
	});

}

// set eq height on columns with provided attr
function setEqHeight() {
	removeEqHeight();

	$("[data-eq-columns]").each(function (i, container) {
		var viewPort = $(container).attr('data-eq-columns');
		if ((viewPort && viewport().width > viewPort) || !viewPort) {
			setInternalMultiRowHeight(container);
		}

	});

	function setInternalMultiRowHeight(container) {
	
		var $children = $(container).find(">*:not([item-eq-height-set])");

		if ($children.length) {
			var parentWidth = container.getBoundingClientRect().width;
	
			// $set = 1;
	
			var $items = $(container).find(">*:not([item-eq-height-set])");
			var initialHeight = null;

			// do loop while sum of children width is smaller than container width
			var width = 0;
			var i = 0;
			var affected = [];
			while (width < parentWidth) {
				var child = $items[i];
				var $child = $(child);
				affected.push($child);
				if ($child.height() > initialHeight) {
					initialHeight = $child.height();
				}

				width += $items[i].getBoundingClientRect().width;
				i++;
			}
	
			if (initialHeight) {
				affected.forEach(function(item, index) {
					item.height(initialHeight);
					item.attr('item-eq-height-set', true);
				});
			}
	
			var items = $(container).find(">*:not([item-eq-height-set])");
			if (items.length != 0) {
				setInternalMultiRowHeight(container);
			} else {
				$(container).attr('data-eq-columns-set', '');
			}
		}
	}

	function removeEqHeight() {
		$("[data-eq-columns][data-eq-columns-set]").each(function (i, container) {
			$(container).find(">*").css("height", "auto").removeAttr('item-eq-height-set');
			$(container).removeAttr('data-eq-columns-set');
		});
	}

}

function viewport() {
	var e = window,
		a = 'inner';
	if (!('innerWidth' in window)) {
		a = 'client';
		e = document.documentElement || document.body;
	}
	return {
		width: e[a + 'Width'],
		height: e[a + 'Height']
	};
}

/**
 * Avtomatsko prikaže elemente s [data-slide-container] z izbrane smeri z izbrano hitrostjo
 * možnosti za direction: 'up','down', 'left', 'right'
 * speed je v ms
 */
function openSlideContainers() {
	var $slideContainers = $("[data-slide-container]");
	$slideContainers.hide().addClass('shown');
	$slideContainers.each(function (index, item) {
		var $direction = $(item).attr("data-slide-container");
		var $speed = $(item).attr("data-slide-speed");
		if (!$speed) {
			$speed = 1000;
		}
		if (!isNaN($speed)) {
			$speed = parseInt($speed);
		}
		$(item).show("slide", {
			direction: $direction
		}, $speed);
	});
}


/**
 * Binda element kot triger za prikazovanje druegaga elementa s pomočjo slidanja (jquery ui)
 * možnosti za direction: 'up','down', 'left', 'right'
 * speed je v ms
 */
function bindSlideAnchor() {
	$("[data-slide-anchor]").click('click', function () {
		const $container = $($(this).attr('data-slide-anchor'));
		const $anchor = $(this);

		// show container
		let $speed = $container.attr('data-slide-speed');
		if (!$speed) {
			$speed = 1000;
		}
		$speed = parseInt($speed);
		let $direction = $container.attr('data-slide-start-direction');
		if (!$direction) {
			$direction = 'up';
		}

		// hide container if already shown
		if ($container.attr('data-slide-target') !== null) {
			if ($container.hasClass('shown')) {
				$container.hide("slide", {
					direction: $direction
				}, $speed, function () {
					$container.removeClass('shown');
					$anchor.removeClass('slide-toggle-on');
				});
			} else {
				$container.show("slide", {
					direction: $direction
				}, $speed, function () {
					$container.addClass('shown');
					$anchor.addClass('slide-toggle-on');
				});
			}
		}
	});
}

// autoscrolls to element with [data-scroll-to-on-ready] attribute on window load -> 
// if you add directive [data-scroll-to-include-height] to other elements it includes its height
// to move the scroll for its height lower
function scrollToOnLoadDirective() {

	var $scrollTo = $("[data-scroll-to-on-ready]");
	if ($scrollTo.length != 0) {
		//first found
		var $item = $scrollTo[0];
		//get any items height to be added to
		var includeOtherHeight = 0;
		$("[data-scroll-to-include-height]").each(function (index, item) {
			includeOtherHeight += $(item).height();
		});
		var scrollTop = $($item).offset().top;


		$("html, body").animate({
			scrollTop: scrollTop - includeOtherHeight
		}, 600);

	}
}

/**Functions that dont require document to be ready */
initilizeLanguageSettings();


jQuery(document).ready(function () {

	var options = {
		viewport: {
			size: viewport,
			definition: {
				xs: 480,
				sm: 768,
				md: 992,
				lg: 1230
			}
		}
	}

	require('./lib/vertical-align/vertical-align');

	require("./various-utils")(jQuery);
	
	// main menu bootstrap
	require("./main-menu-bootstrap")(options);

	// main menu legacy - uncomment if needed
	//require("./main-menu-legacy");

	/* --- Search form autocomplete --- */
	initializeAutoComplete();

	$('.input-datepicker').datePicker({
		startDate: '01.01.1900'
	});

	/*--- poll ---*/
	jQuery("form#poll-form").submit(function () {
		var responseData = '';
		var lng = jQuery('#pollLng').val();
		if (jQuery('#multi-answers').val() != '1')
			// one answer
			responseData = jQuery("form#poll-form input:checked").val();
		else {
			// multiple answers
			jQuery("form#poll-form input:checked").each(function () {
				responseData += this.value + ' ';
			});
		}
		jQuery.post("/util/ajaxresponse.php?lng=" + lng, {
			func: "poll",
			response: responseData
		}, function (html) {
			showPoll(html);
		});
		return false;
	});

	function showPoll(htmlResponse) {
		jQuery("#poll-container").html(htmlResponse);
		jQuery("#poll-container img").each(function () {
			var tmp = jQuery(this).attr("class");
			var aVals = tmp.match(/[0-9]+$/); // get number at the end of the string
			var val = aVals[0];
			jQuery(this).animate({
				width: val + "px"
			}, 1000);
		});
	}


	/*--- FAQ ---*/
	if ($("div#faq-form-section").length) {
		$("p#faq-form-toggle").slideDown();
		$("p#faq-form-toggle").click(function () {
			$("p#faq-form-toggle").slideUp(500);
			$("div#faq-form-section").slideToggle(500);
		});
	}

	if ($("div#faq-list").length) {
		$("div#faq-list h2").click(function () {
			$(this).next("dl.faq-list").slideToggle(500);
			$(this).next("dl.faq-list").toggleClass('open');
			$(this).toggleClass('open');
		});
	}

	/* --- anchor click scrolling --- */
	/*$('a[href^="#"]').click(function (e) {
		// scroll to anchor if there is actually more after the # sign in the link
		if ($(this).attr('href').length > 1) {
			var scrollToElementName = $(this).attr('href').substr($(this).attr('href').indexOf("#") + 1);
			scrollTo = $("a[name=" + scrollToElementName + "]").offset().top;
			$('html, body').animate({
				scrollTop: scrollTo
			}, 500);
			e.preventDefault();
		}
	});*/

	// Select all links with hashes
$('a[href*="#"]')
// Remove links that don't actually link to anything
.not('[href="#"]')
.not('[href="#0"]')
.not('.nav-link')
.click(function(event) {
  // On-page links
  if (
	location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
	&& 
	location.hostname == this.hostname
  ) {
	// Figure out element to scroll to
	var target = $(this.hash);
	target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
	// Does a scroll target exist?
	if (target.length) {
	  // Only prevent default if animation is actually gonna happen
	  event.preventDefault();
	  $('html, body').animate({
		scrollTop: target.offset().top
	  }, 1000, function() {
		// Callback after animation
		// Must change focus!
		var $target = $(target);
		$target.focus();
		if ($target.is(":focus")) { // Checking if the target was focused
		  return false;
		} else {
		  $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
		  $target.focus(); // Set focus again
		};
	  });
	}
  }
});


	/* --- Calendar --- */
	function initCalendar() {
		// advance a month
		var strId = $('#calendar-response').attr('class');

		if (strId) {
			// Get language
			var aLng = strId.split('_');
			var lng = aLng[1];

			// Load next month
			$("#cal-next-month").click(function (e) {
				var cName = $("#cal-next-month").attr("class");
				var y = cName.substr(6, 4);
				var m = cName.substr(10, 2);
				$("#calendar-response").load("/util/ajaxresponse.php?lng=" + lng, {
					'func': 'outputCalendar',
					'y': y,
					'm': m,
					'eventsStrId': strId
				}, function () {
					initCalendar();
				});
				e.preventDefault();
			});

			// backtrack a month
			$("#cal-prev-month").click(function (e) {
				var cName = $("#cal-prev-month").attr("class");
				var y = cName.substr(6, 4);
				var m = cName.substr(10, 2);
				$("#calendar-response").load("/util/ajaxresponse.php?lng=" + lng, {
					'func': 'outputCalendar',
					'y': y,
					'm': m,
					'eventsStrId': strId
				}, function () {
					initCalendar();
				});
				e.preventDefault();
			});
		}
	}


	/* --- Photogallery --- */
	function initPhotogallery() {
		// Apply orientation classes to the gallery list images
		if ($("#photo-gallery-list").length) {
			$("#photo-gallery-list .photo-gallery-item:not(.server-size)").each(function () {
				var image = $(this).find("img.photo-gallery");

				if (image.height() > image.width()) {
					// portrait
					$(this).addClass("portrait");
				} else {
					// lanscape
					$(this).addClass("landscape");
				}
			});
		}

		// Apply orientation classes to the gallery images
		if ($("#photo-gallery-container").length) {
			$("#photo-gallery-container .photo-gallery-item:not(.server-size)").each(function () {
				var image = $(this).find("img.photo-gallery");

				if (image.height() > image.width()) {
					// portrait
					$(this).addClass("portrait");
				} else {
					// lanscape
					$(this).addClass("landscape");
				}
			});
		}
	}

	initPhotogallery(); // initialize the photogallery



	/* --- Photolist --- */
	// resize the photolist widths for non-standard width photos
	function resizePhotolist() {
		if (jQuery("dl.photo-list").length) {
			var imgWidth = jQuery("dl.photo-list img:first").width();
			var dlWidth = jQuery("dl.photo-list").width();

			jQuery("dl.photo-list dt, dl.photo-list dd.summary").width(dlWidth - imgWidth - 10 + "px");
		}
	}

	/* --- cart ajax --- */
	function addCart() {
		jQuery(".btnCart").click(function (e) {
			var idValue = $(this).attr("id");
			var aId = idValue.split('-');

			var id = aId[1];
			var quantity = $(this).prevAll('p').find("input[name=quantity]").val();
			var price = $(this).prevAll("input[name=price]").val();
			var lng = $(this).prevAll("input[name=lng]").val();
			jQuery($("#cart-wrapper")).load("/util/ajaxresponse.php", {
				'act': 'addCart',
				'lng': lng,
				'quantity': quantity,
				'price': price,
				'articleId': id
			}, function () {
				removeCart();
			});
			e.preventDefault();
		});
	}

	function removeCart() {
		jQuery(".imgCartEdit").click(function (e) {
			var idValue = $(this).attr("id");
			var id = idValue.substring(8);
			var lng = idValue.substr(4, 3);
			jQuery($("#cart-wrapper")).load("/util/ajaxresponse.php", {
				'act': 'removeCart',
				'lng': lng,
				'articleId': id
			}, function () {
				removeCart();
			});
			jQuery($("#editCart")).load("/util/ajaxresponse.php", {
				'act': 'updateShopCart',
				'lng': lng,
				'articleId': id
			}, function () {
				removeCart();
				updateCart();
			});
			e.preventDefault();
		});
	}

	function updateCart() {
		jQuery(".quantity-num").keypress(function (e) {
			if (e.which == 13) {
				var idValue = $(this).attr("id");
				var id = idValue.substring(8);
				var lng = idValue.substr(4, 3);
				var quantity = $(this).val();
				jQuery($("#cart-wrapper")).load("/util/ajaxresponse.php", {
					'act': 'updateCart',
					'lng': lng,
					'articleId': id,
					'quantity': quantity
				}, function () {
					removeCart();
				});
				jQuery($("#editCart")).load("/util/ajaxresponse.php", {
					'act': 'updateCartFrom',
					'lng': lng,
					'articleId': id,
					'quantity': quantity
				}, function () {
					updateCart();
					removeCart();
				});

			}
		});
	}

	function fixMobileTables() {
		// Wrap the tables, which are too wide with an overflow div
		$("article table").each(function () {
			var tWidth = $(this).width();
			var aWidth = $(this).parents('article').eq(0).width();
			if (tWidth > aWidth) {
				if ($(this).parent().hasClass("table-wrapper") == false) {
					$(this).wrap('<div class="table-wrapper"></div>').parent().css({
						'width': aWidth,
						'overflow': 'hidden',
						'overflow-x': 'scroll'
					});
				} else {
					$(this).parent(".table-wrapper").css({
						'width': aWidth
					});
				}
			} else {
				$(this).parent(".table-wrapper").css({
					'width': 'auto',
					'overflow': 'visible'
				});
			}
		});
	}
	fixMobileTables();

	// stara funkcija za paging
	/*function initNewsPaging() {
		if ($("ul.paging").length) {
			$("ul.paging a").click(function (e) {
				var link = $(this).attr("href");
				var aLink = link.split("/");
				var page = aLink[aLink.length - 2];

				var catFilter = $("select[name=nws_cat_filter]").val();

				$("#pagedNewsArchive").load("/util/ajaxresponse.php?lng=" + pageLng, {
					'func': 'pagedNewsArchive',
					'page': page,
					'catFilter': catFilter
				}, function () {
					initNewsPaging();
				});
				e.preventDefault();
			});
		}
	}
	initNewsPaging();*/

	// nova funkcija za paging
	function initNewNewsPaging() {
		var strId = $("#pagination").attr('data-url');

        window.pagObj = $('#pagination').twbsPagination({
            totalPages: $("#pagination").attr('data-total-pages'),
            visiblePages: 7,
            onPageClick: function (event, page) {
				$("#pagedNewsArchive").load("/util/ajaxresponse.php?lng=" + pageLng, {
					'func': 'pagedNewsArchive',
					'page': page-1,
					'strId': strId
				});		
            }
        }).on('page', function (event, page) {
            //console.info(page + ' (from event listening)');
        });
	}	
	initNewNewsPaging();

	function paggingInt() {
		jQuery('.select-page').click(function (e) {
			e.preventDefault();
			var aPage = jQuery(this).attr('id').split('-');
			var strId = jQuery('#pagging-content-wraper').attr('class');

			$("#pagging-content-wraper").load("/util/ajaxresponse.php?lng=" + lng, {
				'func': 'questionsPagging',
				'page': aPage[1],
				'strId': strId
			}, function () {
				paggingInt();
			});

		})

	}

	paggingInt();

	function submitHelper() {
		$('.submit-helper').on('click', function(ev) {
			ev.preventDefault();
			ev.stopPropagation();

			$(this).closest('form').submit();
		});
	}
	submitHelper();

	function continueButton(){
		jQuery('#button-continue').click(function(){
			var modelElId = jQuery('#currentModelEl').val();
			var answerId = jQuery('#answerId').val();
			var presentValueId = jQuery('input[name=optionsRadiosPresent]:checked').val();
			var futureValueId = jQuery('input[name=optionsRadiosFuture]:checked').val();
			jQuery('#present tbody th').removeClass('has-error');
			jQuery('#present th.th-present').removeClass('has-error');
			jQuery('#present th.th-future').removeClass('has-error');
			if(presentValueId == undefined){
				
				//jQuery('#present tbody th').addClass('has-error');
				
				jQuery('#present th.th-present').addClass('has-error');
				if(futureValueId == undefined){
					jQuery('#present th.th-future').addClass('has-error');
					jQuery('#present th:first').prepend('<p id="assessment-error">You must select one option for present and future.</p>');
				}
				if (!$("#assessment-error").length) {
					jQuery('#present th:first').prepend('<p id="assessment-error">You must select one option for present.</p>');
				}
				return;
			}
			if(futureValueId == undefined){
				//jQuery('#present tbody th').addClass('has-error');
				
				jQuery('#present th.th-future').addClass('has-error');
				if (!$("#assessment-error").length) {
					jQuery('#present th:first').prepend('<p id="assessment-error">You must select one option for future.</p>');
				}
				return;
			}
			
			$("#assessmentTool").load("/util/ajaxresponse.php?lng="+pageLng, { 'func': 'continue', 'modelElId': modelElId, 'presentValueId': presentValueId, 'futureValueId': futureValueId, 'answerId': answerId }, function() {
				continueButton();
				skipButton();
				backButton();
				initTooltip();
				stepSwitcher();
				questionSwitcher();
				initHelpButton()
				submitIssue();
				sendInReview();
			});
		})
	}
	continueButton();

	function setTdAsLabel(){
		$('#present td').click(function(){
			$(this).find('input').click();
		});
	}
	//setTdAsLabel();
	
	function skipButton(){
		jQuery('#button-skip').click(function(){
			var modelElId = jQuery('#currentModelEl').val();
			
			$("#assessmentTool").load("/util/ajaxresponse.php?lng="+pageLng, { 'func': 'skip', 'modelElId': modelElId }, function() {
				continueButton();
				skipButton();
				backButton();
				initTooltip();
				stepSwitcher();
				questionSwitcher();
				initHelpButton()
				submitIssue();
				sendInReview();
			});
		})
	}
	skipButton();
	
	function backButton(){
		jQuery('#button-back').click(function(){
			var modelElId = jQuery('#currentModelEl').val();

			$("#assessmentTool").load("/util/ajaxresponse.php?lng="+pageLng, { 'func': 'prev', 'modelElId': modelElId }, function() {
				continueButton();
				skipButton();
				backButton();
				initTooltip();
				stepSwitcher();
				questionSwitcher();
				initHelpButton()
				submitIssue();
				sendInReview();
			});
		})
	}
	backButton();
	
	function stepSwitcher(){
		jQuery('.stepNum').click(function(){
			var elId = jQuery(this).attr('id');
			var aId = elId.split('-');
			var id = aId[1];
			$("#assessmentTool").load("/util/ajaxresponse.php?lng="+pageLng, { 'func': 'showStep', 'modelElId': id }, function() {
				continueButton();
				skipButton();
				backButton();
				initTooltip();
				stepSwitcher();
				questionSwitcher();
				initHelpButton()
				submitIssue();
				sendInReview();
			});
		})
	}
	stepSwitcher();
	
	function questionSwitcher() {
		jQuery('.questionNum').click(function(){
			var elId = jQuery(this).attr('id');
			var aId = elId.split('-');
			var id = aId[1];
			$("#assessmentTool").load("/util/ajaxresponse.php?lng="+pageLng, { 'func': 'showStep', 'modelElId': id }, function() {
				continueButton();
				skipButton();
				backButton();
				initTooltip();
				stepSwitcher();
				questionSwitcher();
				initHelpButton()
				submitIssue();
				sendInReview();
			});
		})
	}
	questionSwitcher();
	
	function sendInReview(){
		$('#button-review').click(function(){
			$("#assessmentTool").load("/util/ajaxresponse.php?lng="+pageLng, { 'func': 'sendInReview' }, function() {
				var url = $('#urlRedirect').attr('data-url');
				if(url){
					window.location.href = url;
				}
			});
		})
	}
	sendInReview();
	
	function submitIssue(){
		$('#button-submit-issue').click(function(){
			var modelElId = $('#currentModelEl').val();
			var expertIssue = $('#expertIssue').val();
			$("#experts-help-entry").load("/util/ajaxresponse.php?lng="+pageLng, { 'func': 'sendIssue', 'modelElId': modelElId, 'expertIssue': expertIssue }, function() {
				$("#expert-help").load("/util/ajaxresponse.php?lng="+pageLng, { 'func': 'showExpert', 'modelElId': modelElId }, function() {
					
				});	
			});
			
			
		})
	}
	submitIssue();
	
	$("#login-form #button-register").on("click", function(e) {
		e.preventDefault();
		window.location = "/";
	});
	
	$("#login-form #button-forgot-pass").on("click", function(e) {
		e.preventDefault();
		window.location = "/forgot-your-password/";
	});
	
	
	$("#register-form #button-signin").on("click", function(e) {
		e.preventDefault();
		window.location = "/sign-in/";
	});
	
	$('select[name=orgLegalStatus]').change(function(){
		var val = $(this).val();
		if (val == 'SME') {
			$('#orgCoreBussinesSme').removeClass('hidden');
			$('#orgCoreBussinesCci').addClass('hidden');
		} else if (val == 'CCI') {
			$('#orgCoreBussinesSme').addClass('hidden');
			$('#orgCoreBussinesCci').removeClass('hidden');
		} else {
			$('#orgCoreBussinesSme').addClass('hidden');
			$('#orgCoreBussinesCci').addClass('hidden');
		}
	});
	
	// Client detail -> Notes (Edit mode)
	function initNotesForm() {
		if ($('#note-entry').length) {
			$('#note-form button[type=submit]').on("click", function(e) {
				e.preventDefault();
				var textArea = $('#note-form textarea');
				var clientId = $('#note-form').attr('data-client-id');
				var notes = textArea.val();
				textArea.prop('disabled', true);
				textArea.css('cursor', 'progress');
				$(this).text('Saving...');
				$(this).css('cursor', 'progress');
				$(this).prop('disabled', true);
				
				$('#notes-container').load("/util/ajaxresponse.php", { 'func': 'saveNotes', 'notes': notes, 'clientId': clientId }, function() {
					initNotesView();
				});
			});
		}
	}
	initNotesForm();
	
	// Client detail -> Notes (View mode)
	function initNotesView() {
		if ($('#note-entry').length) {
			$('#notes-container button').on("click", function(e) {
				var notes = $('#notes-container p').text();
				var clientId = $(this).attr('data-client-id');
				$(this).text('Loading...');
				$(this).css('cursor', 'progress');
				$(this).prop('disabled', true);
				
				$('#notes-container').load("/util/ajaxresponse.php", { 'func': 'editNotes', 'notes': notes, 'clientId': clientId }, function() {
					initNotesForm();
				});
			});
		}
	}
	initNotesView();
	
	// Client details -> Change user status
	if ($('#note-entry').length) {
		$("#change-status-form button[type=submit]").on("click", function(e) {
			e.preventDefault();
			var button = $(this);
			var newStatus = $("input[name=accountStatus]:checked").eq(0).val();
			var clientId = $("#change-status-form").attr('data-client-id');
			var originalButtonText = button.text();
			
			button.text('Saving...');
			button.css('cursor', 'progress');
			button.prop('disabled', true);
			
			$.post("/util/ajaxresponse.php", { 'func': 'changeStatus', 'status': newStatus, 'clientId': clientId }, function() {
				button.text(originalButtonText);
				button.css('cursor', 'default');
				button.prop('disabled', false);
			});
		});
	}
	
	// Client details -> Issues
	if ($('#client-issues').length) {
		$('.issue-form button[type=submit]').on("click", function(e) {
			e.preventDefault();
			var thisForm = $(this).parents('.issue-form').eq(0);
			var textArea = thisForm.find('textarea');
			var clientId = thisForm.attr('data-client-id');
			var issueId = thisForm.attr('data-issue-id');
			var attributeId = thisForm.attr('data-attribute-id');
			var answer = textArea.val();
			textArea.prop('disabled', true);
			textArea.css('cursor', 'progress');
			$(this).text('Saving...');
			$(this).css('cursor', 'progress');
			$(this).prop('disabled', true);
			$('#issue-container-'+issueId).load("/util/ajaxresponse.php", { 
				'func': 'saveIssueAnswer', 
				'answer': answer, 
				'issueId': issueId, 
				'attributeId': attributeId, 
				'clientId': clientId 
			});
		});
	}

	function initTooltip(){
		$('[data-toggle="tooltip"]').tooltip({
			animation: false
		});
	}
	initTooltip();
	
	function initHelpButton(){
		$('#button-help').on('click', function(e) {
			$('#experts-help-entry').toggle();
			
			e.preventDefault();
		});
	}
	initHelpButton();
	hideTrainingContent();

	if($('#diva-map').length) {
		var oUserData = '';
		var loginId = $('.login-btn').attr('id');
		
		function initialiseForesterMap2(){
			if(document.getElementById('diva-map')){
				var mymap = L.map('diva-map').setView([46.049194, 14.504155], 11);
			
				L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
					maxZoom: 18,
					attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, ' +
						'<a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, ' +
						'Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
					id: 'mapbox.streets'
				}).addTo(mymap);
				
				
				var lng = pageLng;
				var forester = jQuery('#name').val(); 
				//var municipy = jQuery('#municipy').val(); 
				var region = jQuery('#region').val(); 
				var aServices = [];
				$(":checked").each(function() {
					aServices.push($(this).val());
				});
				
				var addUrl = '';
				 var sPageURL = decodeURIComponent(window.location.search.substring(1)),
			        sURLVariables = sPageURL.split('&'),
			        sParameterName,
			        i;
				 if(sPageURL != ''){
					 addUrl = '?'+sPageURL;
				 }
				$.ajax({ type: "POST", url: "/util/ajaxresponse.php"+addUrl, data: { 'func' : 'getAddresses', 'lng' : lng, 'show' : 'all'} })
				.done(function(results) {
					
					
					var oUserData = jQuery.parseJSON(results);
					var markerClusters = L.markerClusterGroup({
						maxClusterRadius: 50
					});
					var markersData = new Array();
					var i = 0;
					
					var count = oUserData.length;
					for(count in oUserData) {
						
						if (oUserData[count].latitude != null && oUserData[count].longitude != null) {
							var latitude = oUserData[count].latitude;
							var longitude = oUserData[count].longitude;
							var dataTitle = '';
							var content = '';
							var city = '';
							var id = '';
							var url = '';
							
							/*if(oUserData[count].academic != null){
								nameSurname += oUserData[count].academic+' ';
							}*/
							if(oUserData[count].title != null && oUserData[count].title != ''){
								dataTitle += oUserData[count].title;
							}
							if(oUserData[count].city != null && oUserData[count].city != ''){
								content += oUserData[count].city+'<br />';
							}

							if(oUserData[count].website != null && oUserData[count].website != ''){
								content += '<strong>W:</strong> <a href="'+oUserData[count].website+'" target="_blank">'+oUserData[count].website+'</a></br />';
							}
						
							
	
							
							if ((markersData.length > 0) && (markersData[i-1].longitude == longitude) && (markersData[i-1].latitude == latitude)) {				
								var cnt = markersData[i-1].content;
								cnt += '<br />'+content;
								
								markersData[i-1].content = cnt;			
							}  else {				
								var markerData = {latitude:latitude, longitude:longitude, title:dataTitle, content:content, url: url, id: id};
								
								markersData.push(markerData);
								i++;
							}
							markersData
						}	else {
							
							var address = oUserData[count].address+" "+oUserData[count].postCode;
							/*
							$.get(location.protocol + '//nominatim.openstreetmap.org/search?format=json&q='+address, function(data){
								console.log('nominatim.openstreetmap.org/search?format=json&q='+address);
						       
						    });*/
						    var markers = GetLocationLeaflet(oUserData[count],mymap);
							//var markers = GetLocation(oUserData[count],map);
						}			
					}
					
					var myIcon = L.icon({iconUrl: '/images/marker-icon.png'}); // inicializacija objekta z ikono
					var myOverIcon = L.icon({iconUrl: '/images/map-icon-red.png'});
					//var jMarkers = $.parseJSON(markersJson);
					//var jMarkers = oUserData;
					var aBouds = [];
					var testmarker =[];
					var key = markersData.length;
					for (key in markersData) {
						var markerData = markersData[key];
						var aMerker = [parseFloat(markerData.latitude),parseFloat(markerData.longitude)];
						aBouds.push(aMerker) 
					
			
						var infoWindowContent = 
							'<div class="info_content">' +
							'<h1 class=\'iw-title logedin-title\' onclick="window.location=\''+markerData.url+markerData.id+'\'">'+markerData.title+'</h1>' +
							'<p class="iw-content">'+markerData.content+'</p>' +             
							'</div>';
						
						testmarker[key] = new L.marker(aMerker, {icon: myIcon})
							.bindPopup(infoWindowContent) // dodajanje teksta v popup
							;
						
						/*
						var m = L.marker( aMerker, {icon: myIcon} )
		                  .bindPopup( infoWindowContent );
						*/
						markerClusters.addLayer(testmarker[key]);
						/*
						testmarker[i].on('mouseover', function(e) { //zamenjava ikone ob mouseover
							e.target.setIcon(myOverIcon);
					    });
					    testmarker[i].on('mouseout', function(e) { //zamenjava ikone ob mouseout
							e.target.setIcon(myIcon);
					    });*/
					}
					mymap.addLayer(markerClusters);
					mymap.fitBounds(aBouds);
					
					
					
					//var group = new L.featureGroup(aBouds);
					//mymap.fitBounds(group.getBounds());
				})
				//mymap.setMaxBounds(mymap.getBounds());
			}
		}
		initialiseForesterMap2();
		
		
		var oUserData = '';
		var loginId = $('.login-btn').attr('id');
		
		
		
		function initialiseForesterMap(){
			return;
			var mapId = document.getElementById('map-canvas');
			
			
			
			if(mapId != null){
				
				var map;
				var bounds = new google.maps.LatLngBounds();
			    var latlng = new google.maps.LatLng(46.049194, 14.504155);

			      mapOptions = {
			        zoom: 7,
			        center: latlng,
			      }
			                    
			    // Display a map on the page
			    map = new google.maps.Map(mapId, mapOptions);
				
				var lng = jQuery("#formLng").val();
				var forester = jQuery('#name').val(); 
				//var municipy = jQuery('#municipy').val(); 
				var region = jQuery('#region').val(); 
				var aServices = [];
				$(":checked").each(function() {
					aServices.push($(this).val());
				});
				
				/*
				var forester = getUrlParameter('forester');
				var region = getUrlParameter('region');
				var aServices = getUrlParameter('aServices');
				var test = $.urlParam('aServices');
				*/
				var addUrl = '';
				 var sPageURL = decodeURIComponent(window.location.search.substring(1)),
			        sURLVariables = sPageURL.split('&'),
			        sParameterName,
			        i;
				 if(sPageURL != ''){
					 addUrl = '?'+sPageURL;
				 }
				 

				 /*
			    for (i = 0; i < sURLVariables.length; i++) {
			        sParameterName = sURLVariables[i].split('=');
			        if (sParameterName[0] === sParam) {
			            return sParameterName[1] === undefined ? true : sParameterName[1];
			        }
			    }*/
				
				
				
				$.ajax({
				  url: "/util/ajaxresponse.php"+addUrl,
				  method: "POST",
				  data: { 'func' : 'getAddresses', 'lng' : lng, 'show' : 'all' }
				}).done(function(results) {
	/*-------------------------------------------------------------------------------------*/
					
					var oUserData = jQuery.parseJSON(results);
					var markersData = new Array();
					var i = 0;
					for(count in oUserData) {
						
						if (oUserData[count].latitude != null && oUserData[count].longitude != null) {
							var latitude = oUserData[count].latitude;
							var longitude = oUserData[count].longitude;
							var dataTitle = '';
							var content = '';
							var city = '';
							
							/*if(oUserData[count].academic != null){
								nameSurname += oUserData[count].academic+' ';
							}*/
							if(oUserData[count].company != null){
								dataTitle += oUserData[count].company+'<br />'+oUserData[count].address+', '+oUserData[count].postCode;
							}
							if(oUserData[count].forester_id != null){
								content += '<strong>ID:</strong> '+oUserData[count].forester_id+'</br />';
							}
							if(oUserData[count].municipy != null){
								//content += '<strong>Občina:</strong> '+oUserData[count].municipy+'</br />';
							}
							if(oUserData[count].email != null){
								//content += '<strong>E-pošta:</strong> <span class="script-mail">'+oUserData[count].email+'</span></br />';
							}
							if(oUserData[count].forester_services != null){
								var services = oUserData[count].forester_services;
								content += '<strong>Storitve ponudnika:</strong><br />';
								if(services.indexOf('construction') !== -1){
									content += '<img src="/images/backgrounds/icons/gradb2-sm.png" width="40" />';
								}
								if(services.indexOf('saw_logging') !== -1){
									content += '<img src="/images/backgrounds/icons/secnja2-sm2.png" width="40" />';
								}
								if(services.indexOf('tractor_harvesting') !== -1){
									content += '<img src="/images/backgrounds/icons/spravilo2-sm2.png" width="40" />';
								}
								if(services.indexOf('wire_harness') !== -1){
									content += '<img src="/images/backgrounds/icons/zicnisko2-sm2.png" width="40" />';
								}
								if(services.indexOf('cultivation') !== -1){
									content += '<img src="/images/backgrounds/icons/gojenje2-sm2.png" width="40" />';
								}
								if(services.indexOf('mechanical_logging') !== -1){
									content += '<img src="/images/backgrounds/icons/strojna2-sm2.png" width="40" />';
								}
								if(services.indexOf('chopper') !== -1){
									content += '<img src="/images/backgrounds/icons/sekanci2-sm.png" width="40" />';
								}
								if(services.indexOf('transport') !== -1){
									content += '<img src="/images/backgrounds/icons/prevoz2-sm.png" width="40" />';
								}
								
							}
							//login button
							
							/*if (loginId == 'buttonLogIn') {
								content += '<a href="#" type="button" class="btn btn-xs btn-success navbar-btn login-btn" id="login-header-button" data-toggle="modal" data-target="#loginHeader">Za člane</a>';
							} else {
								content += '<a href="'+oUserData[count].url+oUserData[count].id+'/" type="button" class="btn btn-xs btn-success navbar-btn login-btn" id="login-header-button">več informacij</a>';
							}*/
							
							
							if ((markersData.length > 0) && (markersData[i-1].longitude == longitude) && (markersData[i-1].latitude == latitude)) {				
								var cnt = markersData[i-1].content;
								cnt += '<br />'+content;
								
								markersData[i-1].content = cnt;			
							}  else {				
								var markerData = {latitude:latitude, longitude:longitude, title:dataTitle, content:content};
								
								markersData.push(markerData);
								i++;
							}
							markersData
						}	else {
							var address = oUserData[count].city+" "+oUserData[count].countryTitleEng;
							var markers = GetLocation(oUserData[count],map);
						}			
					}

	/*-------------------------------------------------------------------------------------*/
				
				////if(oUserData[count].id != undefined){
					var bounds = new google.maps.LatLngBounds();
					var markers = [];
					var count = 0;
					for (key in markersData) {
						var markerData = markersData[key];
						var position = new google.maps.LatLng(markerData.latitude, markerData.longitude);
						bounds.extend(position);
						marker = new google.maps.Marker({
							position: position,
							map: map,
							title: markerData.city
						});
						markers.push(marker);
							//if (loginId == 'buttonLogIn') {
							//} else {
							//};						
						//bound.extend(marker.getPosition());
						if (loginId == 'buttonLogIn') {
							var infoWindowContent = 
								'<div class="info_content">' +
								'<h1 class=\'iw-title logedin-title\' data-toggle="modal" data-target="#loginHeader">'+markerData.title+'<i class="fa fa-sign-in" aria-hidden="true"></i></h1>' +
								'<p class="iw-content">'+markerData.content+'</p>' + 								
								'</div>';
						} else {
							var infoWindowContent = 
								'<div class="info_content">' +
								'<h1 class=\'iw-title logedin-title\' onclick="window.location=\''+oUserData[count].url+oUserData[count].id+'\'">'+markerData.title+'</h1>' +
								'<p class="iw-content">'+markerData.content+'</p>' +             
								'</div>';
						}

						
						if(markerData.city != '' || markerData.content != ''){
							var infoWindow = new google.maps.InfoWindow();	
							google.maps.event.addListener(marker, 'click', (function(marker,infoWindowContent) {
								return function() {
									infoWindow.setContent(infoWindowContent);
									infoWindow.open(map, marker);
								}
							})(marker,infoWindowContent));
						}
						count++;
					}
					var mcOptions = {gridSize: 40, maxZoom: 11, imagePath: '../images/m'};
					var markerCluster = new MarkerClusterer(map, markers, mcOptions);

					//map.fitBounds(bounds);	
					
				});	
				//map.fitBounds(bounds);	
			}
		}

		/*function setLatLong() {
		
			var geocoder = new google.maps.Geocoder();
			var address = $('#rgs12').val() + ' ' + $('#rgs13').val()
			geocoder.geocode({ 'address': address }, function (results, status) {
				if (status == google.maps.GeocoderStatus.OK) {
					var latitude = results[0].geometry.location.lat();
					var longitude = results[0].geometry.location.lng();
					$('#latitude').val(latitude);
					$('#longitude').val(longitude);
				}
			});
			
		}*/	
		
		$.urlParam = function(name){
			var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
			return results[1] || 0;
		}
		
		function GetLocationLeaflet(json,map){
		
			var address = '';
			var address2 = '';
			if(json.address){
				address += json.address;
			}
			if(json.city){
				if(address != ''){
					address += ' ';
				}
				address += json.city;
				address2 = json.city;
			}
			
			$.get(location.protocol + '//nominatim.openstreetmap.org/search?format=json&q='+address, function(data){
				//var oLocation = jQuery.parseJSON(data);
				
				if(data[0] == undefined){
					$.get(location.protocol + '//nominatim.openstreetmap.org/search?format=json&q='+address2, function(data){
						if(data[0] == undefined){
							return;
						}
						var title = '';
						var content = '';
						/*if(json.academic != null){
							title += json.academic+' ';
						}*/
						/*
						title += json.forester_name+' '+json.forester_surname;
						
						if(json.faculty_name != null){
							content += json.company+'<br />';
						}*/
						title += json.company;
						if(json.address != null){
							content += json.address+'<br />';
						}
						content += '<span style="color:red">'+json.email+'</spanc><br />';
						if(json.gsm != null){
							content += '<span style="color:red">'+json.gsm+'</spanc><br />';
						}
						
						var infoWindowContent = 
							'<div class="info_content">' +
							'<h3>'+title+'</h3>' +
							'<p>'+content+'</p>' +        
							'</div>';
						
						var latitude = data[0].lat;
						var longitude = data[0].lon;
						$.ajax({
						method: "POST",
						url: "/util/ajaxresponse.php",
						data: {'func' : 'addLatLog',  'id' : json.id, 'latitude' : latitude, 'longitude' : longitude }
						})
						
						var myIcon = L.icon({iconUrl: '/images/marker-icon.png'});
						L.marker(aMerker, {icon: myIcon})
						.bindPopup(infoWindowContent) // dodajanje teksta v popup
						.addTo(mymap);
					
					});
					return;
				}
				var title = '';
            	var content = '';
            	/*if(json.academic != null){
            		title += json.academic+' ';
            	}*/
            	/*
            	title += json.forester_name+' '+json.forester_surname;
            	
            	if(json.faculty_name != null){
            		content += json.company+'<br />';
            	}*/
            	title += json.company;
            	if(json.address != null){
            		content += json.address+'<br />';
            	}
            	content += '<span style="color:red">'+json.email+'</spanc><br />';
            	if(json.gsm != null){
            		content += '<span style="color:red">'+json.gsm+'</spanc><br />';
            	}
            	
            	var infoWindowContent = 
            	    '<div class="info_content">' +
            	    '<h3>'+title+'</h3>' +
            	    '<p>'+content+'</p>' +        
            	    '</div>';
            	
                var latitude = data[0].lat;
                var longitude = data[0].lon;
				$.ajax({
				  method: "POST",
				  url: "/util/ajaxresponse.php",
				  data: {'func' : 'addLatLog',  'id' : json.id, 'latitude' : latitude, 'longitude' : longitude }
				})
				
				var myIcon = L.icon({iconUrl: '/images/marker-icon.png'});
				L.marker(aMerker, {icon: myIcon})
				.bindPopup(infoWindowContent) // dodajanje teksta v popup
				.addTo(mymap);
		       
		    });
		}

		
		function GetLocation(json,map) {

	        var geocoder = new google.maps.Geocoder();
			var address = json.address+' '+json.city+', '+json.municipy;        
			//var address = json.city+' Slovenia';        
	        geocoder.geocode({ 'address': address }, function (results, status) {
				if (status == google.maps.GeocoderStatus.OK) {
	            	
	            	var title = '';
	            	var content = '';
	            	/*if(json.academic != null){
	            		title += json.academic+' ';
	            	}*/
	            	/*
	            	title += json.forester_name+' '+json.forester_surname;
	            	
	            	if(json.faculty_name != null){
	            		content += json.company+'<br />';
	            	}*/
	            	title += json.company;
	            	if(json.address != null){
	            		content += json.address+'<br />';
	            	}
	            	content += '<span style="color:red">'+json.email+'</spanc><br />';
	            	if(json.gsm != null){
	            		content += '<span style="color:red">'+json.gsm+'</spanc><br />';
	            	}
	            	
	            	var infoWindowContent = 
	            	    '<div class="info_content">' +
	            	    '<h3>'+title+'</h3>' +
	            	    '<p>'+content+'</p>' +        
	            	    '</div>';
	            	
	            	var infoWindow = new google.maps.InfoWindow();
	                var latitude = results[0].geometry.location.lat();
	                var longitude = results[0].geometry.location.lng();
					$.ajax({
					  method: "POST",
					  url: "/util/ajaxresponse.php",
					  data: {'func' : 'addLatLog',  'id' : json.id, 'latitude' : latitude, 'longitude' : longitude }
					})
	                var position = new google.maps.LatLng(latitude, longitude);
	                //bounds.extend(position);
	                marker = new google.maps.Marker({
	                    position: position,
	                    map: map,
	                    title: title
	                });
	                
	                google.maps.event.addListener(marker, 'click', (function(marker) {
	                    return function() {
	                        infoWindow.setContent(infoWindowContent);
	                        infoWindow.open(map, marker);
	                    }
	                })(marker));
	                
	            } 
	        });
	        
	        //return coordinates;
	    }
		initialiseForesterMap();	
	}


	$(window).scroll(function() {
		if($(window).scrollTop() == $(document).height() - $(window).height()){
			$('#cookie-button').show();
		}else{
			$('#cookie-button').hide();
		}
	});

	function headerHeight() {
		if($('.header-wrapper').length) {
			var h = $('.animation').height();
			//console.log(h);
			$('.header-wrapper').height(h);
		}
	}

	function rotateText() {
		if($('.header-wrapper').length) {
			var w = $('.transformation-text').outerWidth();
			$('.transformation-text').height(w);
		}		
	}
	$('.header-wrapper').imagesLoaded( function() {
		headerHeight();
		rotateText();
	});

	$("ul.nav-tabs a").click(function (e) {
		e.preventDefault();  
		  $(this).tab('show');
	  });

	$('.tab-content a.nav-link').on('shown.bs.tab', function (e) {
		//console.log($(this).attr('href'));
		$('.subcontent-tab.active.show').addClass('d-flex');
	});

	$('.tab-content a.nav-link').on('hidden.bs.tab', function (e) {
		$('.subcontent-tab').removeClass('d-flex');
	});

	$('.materials-links a').addClass('btn btn-diva btn-warning');

	$('#tab_selector').on('change', function (e) {
		//console.log($(this).val());
		//console.log($(this).val());
	    $('.form-tabs li a').eq($(this).val()).tab('show');
	});

	$('.CODEEMBADE .embed-responsive iframe').addClass('embed-responsive-item');

	
	function viewportRatio() {
		var vw = viewport().width;
		var vh = viewport().height;
		console.log(vh + ' - ' + vw);
		console.log(vh/vw);
		var ratio = vh/vw;
		if(ratio < 0.5 && vw >= 768) {
			$('.logo-lang .lang').addClass('ratio');
		} else {
			$('.logo-lang .lang').removeClass('ratio');
		}
	}

	//viewportRatio();
	
	/* --- "on load" --- */

	$('input:text').textBoxHint(); // titles to input text
	$("article a, ul.grouped-link-list a").markExternalLinks(); // adds class to external links
	initCalendar(); // initialize the calendar

	$("a[rel^='magnific']").magnificPopup({
		type: 'image',
		gallery: {
			enabled: true,
			navigateByImgClick: true,
			tCounter: '%curr%\/%total%'
		},
		closeBtnInside: false,
		closeOnBgClick: true
	});

	/* --- shopping cart --- */
	addCart();
	removeCart();
	updateCart();

	/* Wait for the whole page to load, including images. */
	$(window).load(function () {
		initPhotogallery(); // initialize the photogallery
		$(".owl-carousel").owlCarousel({
			items: 1,
			autoplay: true,
			nav: true,
			dots: true,
			loop: true
		});
		setEqHeight();
		openSlideContainers();
		scrollToOnLoadDirective();
	});

	/* --- window resizing --- */

	$(window).resize(function () {
		// resize and/or reposition elements here
		fixMobileTables();
		setEqHeight();
		$('.header-wrapper').imagesLoaded( function() {
			headerHeight();
			rotateText();
		});
		//viewportRatio();
	});
});


/* --- Non-jQuery functions below --- */

//check if just one checkbox is checked
function isChecked(formId, message) {
	var form = document.getElementById(formId);

	for (i = 0; i < form.elements.length; i++) {
		if (form.elements[i].checked == true) {
			return true;
		}
	}
	alert(message);
	return false;
}

//mail decode
var mDec = function mDec(ensl, enlsShow, addToHref, insertHtml) {
	if (enlsShow == undefined || enlsShow == "") {
		enlsShow = ensl;
	}

	if (addToHref == undefined) {
		addToHref = "";
	}

	let a = "pdlowr=" + ensl;
	let nslv = "";
	for (let i = 0; i < a.length; i++) {
		let n = a.charCodeAt(i) - 3;
		nslv += String.fromCharCode(n);
	}

	let s = "";
	for (let i = 0; i < enlsShow.length; i++) {
		let n = enlsShow.charCodeAt(i);
		if (n >= 35 && n <= 126) {
			s += String.fromCharCode(n - 3);
		} else {
			s += enlsShow.charAt(i);
		}
	}

	if (insertHtml == '') {
		insertHtml = s;
	}

	document.write("<a class=\"email\" href=\"" + nslv + addToHref + "\">" + insertHtml + "</a>");
};


/*
 * function get elements by class name ... simiar to getElementsByTagName
 * leave container arg out, and will default to document.
 */
function getElementsByClassName(className, container) {
	if (!container) {
		container = document;
	}
	if (container.all) {
		var all = container.all;
	} else {
		var all = container.getElementsByTagName('*');
	}
	var arr = [];
	for (var k = 0; k < all.length; k++) {
		if (all[k].className == className) {
			arr[arr.length] = all[k];
		}
	}
	return arr;
}

/*
 * Closes a tree of uls/lis (a menu for example) if scripts are enabled. Else leaves
 * the list open, so it is accessible to other users.
 * Note: this could be done in jQuery, but the list needs to close
 * as soon as it is loaded, so jQuery is not an option here.
 */
function closeList(listId, sublevelsClassName, closeAtLevel) {
	var list = document.getElementById(listId);

	for (var i = closeAtLevel; i < 5; ++i) {
		var aUls = getElementsByClassName(sublevelsClassName + i, list);
		for (var j = 0; j < aUls.length; ++j) {
			if (aUls[j].tagName == 'UL') { // only close ULs
				aUls[j].style.display = "none";
			}
		}
	}
}

/*
 * Closes any element by ID
 */
function hideElementById(elId) {
	var el = document.getElementById(elId);
	el.style.display = "none";
}


if (document.getElementsByTagName) {
	var inputElements = document.getElementsByTagName("input");
	for (var i = 0; inputElements[i]; i++) {
		if (inputElements[i].className && (inputElements[i].className.indexOf("disableAutoComplete") != -1)) {
			inputElements[i].setAttribute("autocomplete", "off");
		}
	}
}

//hide contetn
function hideTrainingContent(){
	$(".training-material-wrapper .content").hide();

}
window.captchaCallback = captchaCallback;
window.urlDirFull = urlDirFull;
window.pageLng = pageLng;
window.initilizeLanguageSettings = initilizeLanguageSettings;
window.initializeAutoComplete = initializeAutoComplete;
window.setEqHeight = setEqHeight;
window.viewport = viewport;
window.openSlideContainers = openSlideContainers;
window.bindSlideAnchor = bindSlideAnchor;
window.scrollToOnLoadDirective = scrollToOnLoadDirective;
window.isChecked = isChecked;
window.mDec = mDec;
window.getElementsByClassName = getElementsByClassName;
window.closeList = closeList;
window.hideElementById = hideElementById;
window.inputElements = inputElements;
window.i = i;
window.hideTrainingContent = hideTrainingContent;
}.call(window, window);